import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-12 px-4 border-t border-[var(--border-light)]" style={{ background: 'var(--bg-page)' }}>
      <div className="max-w-6xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_froma-web-launch/artifacts/8qo2y4tt_1000120027-removebg-preview.png"
              alt="Froma Web"
              className="h-12 w-auto mb-4"
            />
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Professional Shopify Websites & Meta Ads Services to help your business grow online.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3 mb-4">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              <button
                onClick={() => scrollToSection('home')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('why-choose')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Why Choose Us
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Our Process
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection('reviews')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Reviews
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                Contact
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-3 mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex items-start body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                <Phone size={18} className="mr-2 mt-1 flex-shrink-0" />
                {contactInfo.phone}
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-start body-medium hover:text-[var(--accent-text)] transition-colors duration-200"
                style={{ color: 'var(--text-secondary)' }}
              >
                <Mail size={18} className="mr-2 mt-1 flex-shrink-0" />
                {contactInfo.email}
              </a>
              <div
                className="flex items-start body-medium"
                style={{ color: 'var(--text-secondary)' }}
              >
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0" />
                {contactInfo.address}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[var(--border-light)] text-center">
          <p className="body-medium" style={{ color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} Froma Web – Professional Shopify Websites & Meta Ads Services
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
